import React, { Component } from "react";

import { BACKEND_CONFIG } from "../../config/consts";
import BackHeader from "../../components/BackHeader";

class Acord extends Component {
  getPdf(acordId) {
    window.open(
      BACKEND_CONFIG.apiUrl +
        "acord/" +
        acordId +
        "?agencyId=" +
        BACKEND_CONFIG.get("agencyid")
    );
  }

  backToMenu() {
    this.props.history.goBack();
  }

  render() {
    return (
      <div id="reference-tools">
        <BackHeader text="Reference Tools" onClick={() => this.backToMenu()} />
        <h1 className="mb-5">ACORD Applications</h1>
        <div className="acord-label">
          <span to="/reference-tools/payment" className="acord-link">
            <div
              onClick={() => {
                this.getPdf(125);
              }}
              className="link-name"
            >
              <span>ACORD 125 - Commercial</span>
            </div>
          </span>
          <span to="/reference-tools/carrier" className="acord-link">
            <div
              onClick={() => {
                this.getPdf(126);
              }}
              className="link-name"
            >
              <span>ACORD 126 - General Liability</span>
            </div>
          </span>
          <span to="/reference-tools/acord" className="acord-link">
            <div
              onClick={() => {
                this.getPdf(129);
              }}
              className="link-name"
            >
              <span>ACORD 129 - Vehicles Schedule</span>
            </div>
          </span>
          <span to="/reference-tools/bor" className="acord-link">
            <div
              onClick={() => {
                this.getPdf(140);
              }}
              className="link-name"
            >
              <span>ACORD 140 - Property</span>
            </div>
          </span>
          <span to="/reference-tools/direct-carrier" className="acord-link">
            <div
              onClick={() => {
                this.getPdf(146);
              }}
              className="link-name"
            >
              <span>ACORD 146 - Equipment Schedule</span>
            </div>
          </span>
        </div>
      </div>
    );
  }
}

export default Acord;
